/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostSavingsRecommendationsResponse {
    getFixupPrototypeFunction() { return CostSavingsRecommendationsResponse.fixupPrototype; }

    static newInstance(model: Partial<CostSavingsRecommendationsResponse>): CostSavingsRecommendationsResponse {
        let obj = Object.assign(new CostSavingsRecommendationsResponse(), model);
        CostSavingsRecommendationsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostSavingsRecommendationsResponse>): CostSavingsRecommendationsResponse {
        if (!model) return null;
        return CostSavingsRecommendationsResponse.newInstance(<CostSavingsRecommendationsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostSavingsRecommendationsResponse) {
        if (!obj) return;

        models.CostSavingsRecommendationsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostSavingsRecommendationsResponse): boolean {
        Object.setPrototypeOf(obj, CostSavingsRecommendationsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.saving_wise_summary) {
            models.SavingsWiseSummary.fixupPrototype(this.saving_wise_summary);
        }
    }

    /**
     * Currency Selected
     */
    currency_selected: string;

    /**
     * data filter selected if any
     */
    saving_wise_summary: models.SavingsWiseSummary;

}
